module.exports = __webpack_public_path__ + "static/img/default2.42af8f2c.png";